import { useState, useEffect } from 'react';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from 'providers/AuthProvider'
import apiClient, { handleAPIError } from 'helpers/apiService';
import { Col, Row, Stack } from 'react-bootstrap';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
    faCircle, faMessage, faPeopleArrows,
    faBorderStyle,
    faStar
} from '@fortawesome/free-solid-svg-icons';

type StatType = {
    id: number | string;
    icon: IconProp;
    title: string;
    subTitle: string;
    colors: string[];
};


const AllReportsIndicators = () => {

    const auth = useAuth();
    const [data, setData] = useState<StatType[]>();

    const fetchData = async () => {
        try {
            const response = await apiClient.get(
                '/v1/myskills/allreportsindicators',
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );

            const stats: StatType[] = [
                {
                    id: 1,
                    icon: faStar,
                    title: 'Who is talking',
                    subTitle: response.data.who_is_talking,
                    colors: ['theachai-text-red', 'theachai-text-red-100', 'theachai-text-red']
                },
                {
                    id: 2,
                    icon: faMessage,
                    title: 'Same words',
                    subTitle: response.data.same_word,
                    colors: ['theachai-text-yellow', 'theachai-text-yellow-100', 'theachai-text-yellow']
                },
                {
                    id: 3,
                    icon: faPeopleArrows,
                    title: 'Common Language',
                    subTitle: response.data.common_language,
                    colors: ['theachai-text-tiffany', 'theachai-text-tiffany-100', 'theachai-text-tiffany']
                },
                {
                    id: 4,
                    icon: faBorderStyle,
                    title: 'Open Questions',
                    subTitle: response.data.open_questions,
                    colors: ['theachai-text-gray', 'theachai-text-gray-100', 'theachai-text-gray']
                }
            ];
            setData(stats);

        } catch (error) {
            console.error('Request failed:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <Row className="align-items-center g-4 border-bottom pb-4 mt-2 mb-2">
            {data && data.map(stat => (
                <Col xs={12} md="auto" key={stat.id}>
                    <Stat stat={stat} />
                </Col>
            ))}
        </Row>
    );


};

const Stat = ({ stat }: { stat: StatType }) => {
    return (
        <Stack direction="horizontal" className="align-items-center">
            {/* <img src={stat.icon} alt="" height={46} width={46} /> */}
            <span
                className="fa-layers"
                style={{ minHeight: '46px', minWidth: '46px' }}
            >
                <FontAwesomeIcon
                    icon={faSquare}
                    size="2x"
                    className={stat.colors[0]} //{`text-${stat.color}-300`}
                    transform="down-4 rotate--10 left-4"
                />
                <FontAwesomeIcon
                    icon={faCircle}
                    size="2x"
                    className={stat.colors[1]} //{`text-${stat.color}-100 fa-layers-circle`}
                    transform="up-4 right-3 grow-2"
                />
                <FontAwesomeIcon
                    icon={stat.icon}
                    size="1x"
                    className={stat.colors[2]} //{`text-${stat.color}`}
                    transform="shrink-2 up-8 right-6"
                />
            </span>

            <div className="ms-3">
                <h4 className="mb-0">{stat.title}</h4>
                <p className="text-800 fs-8 mb-0">{stat.subTitle}</p>
            </div>
        </Stack>
    );
};

export default AllReportsIndicators;
